import moment from 'moment';

export const displayTime = (date) =>
  date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

export const displayDateTime = (date) =>
  date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

export const displayEventDate = (event) =>
  `${moment(event.start_time).format('M/D/YYYY hh:mm A')} - ${moment(event.end_time).format(
    'M/D/YYYY hh:mm A',
  )} ${event.timezone}`;

const twoNumFormat = (val) => val.toString().padStart(2, '0');

export const dateToServerTimeString = (date) =>
  `${date.getFullYear()}-${twoNumFormat(date.getMonth() + 1)}-${twoNumFormat(
    date.getDate(),
  )} ${twoNumFormat(date.getHours())}:${twoNumFormat(date.getMinutes())}`;
